// Safe currency formatting utility
export const safeCurrencyFormat = (value, locale = 'es-MX') => {
  // Handle null, undefined, or string values
  if (value === null || value === undefined || typeof value === 'string') {
    const numericValue = parseFloat(value || '0')
    if (isNaN(numericValue)) {
      return '0.00'
    }
    return numericValue.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  // Handle numeric values
  if (typeof value === 'number') {
    if (isNaN(value)) {
      return '0.00'
    }
    return value.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  // Fallback for any other type
  return '0.00'
}
